import { isFilled } from "@prismicio/client";
import { PrismicImage, PrismicLink, PrismicRichText } from "@prismicio/react";

/**
 * @typedef {import("@prismicio/client").Content.HeroSlice} HeroSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<HeroSlice>} HeroProps
 * @type {import("react").FC<HeroProps>}
 */
const Hero = ({ slice, index, context }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={` ${index === 0 ? "" : "padding-y"}`}
    >
      <div className="bg-sky-blue text-white relative overflow-hidden">
        {/* Décoration */}
        <div className="bg-electric-blue w-100 h-100 xl:w-130 xl:h-130 rounded-full absolute top-0 left-0 lg:top-16 lg:left-20 blur-[100px]">
        </div>
        <div className="bg-electric-blue w-100 h-100 xl:w-130 xl:h-130 rounded-full absolute bottom-10 right-10 blur-[100px]">
        </div>

        <div className={`padding-x ${index === 0 ? "padding-y-first" : "padding-y"} ${slice.variation === "default" ? "" : "flex-col-reverse"} flex flex-col lg:flex-row framing relative z-10 gap-10 min-[1350px]:gap-20 2xl:gap-25 items-center justify-between`}>
          {/* Image mobile */}
          <div className="lg:hidden w-full">
            {isFilled.image(slice.primary.img_mobile) && (
              <PrismicImage
                field={{
                  ...slice.primary.img_mobile,
                  alt: slice.primary.img_mobile.alt || "Image d'illustration",
                }}
                className=" w-full h-full object-contain rounded-2xl min-h-60"
              />
            )}
            {/* Textes */}
          </div>
          <div className="flex flex-col gap-6 lg:max-w-1/2 w-full">

            {isFilled.richText(slice.primary.title) && (
              <div className="md:text-center lg:text-start">
                <PrismicRichText field={slice.primary.title} />
              </div>
            )}

            {Array.isArray(slice.primary.tag) && slice.primary.tag.length > 0 && (
              <div className="bg-blue w-fit rounded-xl px-4 py-2 hidden md:block m-auto lg:m-0">
                {slice.primary.tag.map((item, index) => (
                  <div key={index} className="flex gap-2 items-center">
                    {isFilled.image(item.picto) && (
                      <div className="w-5 h-5">
                        <PrismicImage
                          className="w-5 h-5 object-contain"
                          field={{
                            ...item.picto,
                            alt: item.picto.alt || "Image d'illustration",
                          }}
                        />
                      </div>
                    )}
                    {isFilled.keyText(item.text) && <span className="text-tag">{item.text}</span>}
                  </div>
                ))}
              </div>
            )}

            {isFilled.richText(slice.primary.description) && (
              <div className="flex flex-col gap-4">
                <PrismicRichText field={slice.primary.description} />
              </div>
            )}

            {isFilled.link(slice.primary.cta) && (
              <PrismicLink field={slice.primary.cta} className="cta cta-orange cta-text mt-4 lg:mt-8 mx-auto lg:mx-0">
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-5 md:w-5">
                  <path d="M25 1L0.999998 10.9988L11.4514 14.5486L15.0012 25L25 1Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M10.8574 15.1425L2.37186 23.628" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                {slice.primary.cta.text}
              </PrismicLink>
            )}

          </div>
          {/* Image desktop */}
          <div className="hidden lg:block flex-1 self-stretch">
            {isFilled.image(slice.primary.img) && (
              <PrismicImage
                field={{
                  ...slice.primary.img,
                  alt: slice.primary.img.alt || "Image d'illustration",
                }}
                className=" rounded-2xl max-w-130 h-full min-[1350px]:max-w-140 object-contain w-full"
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
